import { createMajorArcanaCard } from '../internal/core-builders';
import { MAJOR_CARD_SEEDS } from '../internal/major-config';

export const MAJOR_ARCANA_CORE = MAJOR_CARD_SEEDS.map(createMajorArcanaCard);
